export const createTriggerSelectedLabel = (label: string) => {
  return `${label}, selected`;
};
